import { motion } from "framer-motion";
import { Beer, Beef, Music4 } from "lucide-react";

const IMG = "/spine.jpg";

const FEATURES = [
  {
    icon: Beer,
    title: "Birre alla spina",
    text: "Kozel Lager e San Benoit ambrè e triple, spillate al momento.",
  },
  {
    icon: Beef,
    title: "Carne Fassona",
    text: "Tagliata di fassona piemontese e hamburger di vera carne italiana.",
  },
  {
    icon: Music4,
    title: "DJ set nel weekend",
    text: "Ogni weekend la serata si accende: musica e cocktail fino alle 2.",
  },
];

export default function ChiSiamo() {
  return (
    <section id="chi-siamo" data-testid="chi-siamo-section" className="relative py-24 sm:py-32 bg-[#0D0D0F]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative"
        >
          <div className="absolute -inset-6 bg-[#F49D37]/10 blur-3xl rounded-full" aria-hidden="true" />
          <img
            src={IMG}
            alt="Le spine della birra del pub Lateresina"
            className="relative w-full aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5] object-cover rounded-2xl border border-[#2A2A34] -rotate-1"
          />
          <span className="absolute -bottom-5 -left-2 sm:-left-5 bg-[#D34E36] text-[#F5F2EB] font-display uppercase text-xl sm:text-2xl tracking-wide px-5 py-2 rotate-[-4deg] rounded-lg shadow-2xl">
            Dal cuore di Nizza
          </span>
        </motion.div>

        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-xs font-mono2 tracking-[0.25em] uppercase text-[#F49D37]"
          >
            Chi siamo
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-4"
          >
            Un pub di mattoni,
            <span className="text-[#D34E36]"> birra</span> e notte
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-base sm:text-lg text-stone-300 leading-relaxed mt-6 max-w-lg"
          >
            Lateresina è il punto d'incontro di Nizza Monferrato: si entra per una birra in
            piazza e si resta per la tagliata, un tacos francese e la musica. Cucina aperta la
            sera, bancone sempre pronto, e nel weekend il volume si alza.
          </motion.p>

          <div className="mt-10 space-y-6">
            {FEATURES.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.15 * i }}
                data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-start gap-4"
              >
                <span className="shrink-0 w-11 h-11 rounded-xl bg-[#1C1C22] border border-[#2A2A34] flex items-center justify-center text-[#F49D37]">
                  <f.icon size={20} />
                </span>
                <div>
                  <h3 className="font-display uppercase text-xl tracking-wide">{f.title}</h3>
                  <p className="text-sm text-stone-400 mt-1">{f.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
